module.exports = __webpack_public_path__ + "static/img/fluent-document-24-regular.7b8f5267.svg";